import { useApp } from './app-context';

/** Visible warning whenever the browser has not granted persistent storage. */
export function PersistBanner() {
  const { storage } = useApp();
  if (storage.persist === 'granted') return null;
  return (
    <div class="banner warn" role="alert">
      <strong>Storage is not persistent.</strong>{' '}
      {storage.persist === 'unsupported'
        ? 'This browser does not support persistent storage.'
        : 'Chrome may delete your notes if the device runs low on space.'}{' '}
      Install the app to the home screen (Chrome usually grants persistence to installed apps), and back up regularly.{' '}
      <a href="#/settings">Details</a>
    </div>
  );
}
